<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      title="编辑问卷调查记录"
      width="80%"
      @close="close"
    >
      <el-form ref="form" label-width="150px">
        <el-form-item
          v-for="(item, index) of questionList"
          :key="index"
          :label="item.title"
          prop="title"
        >
          <!-- 单选 -->
          <el-radio-group v-if="item.typehood == 1" v-model="item.answer[0]">
            <el-radio
              v-for="(option, i) of item.options"
              :key="i"
              :label="option"
            >
              {{ option }}
            </el-radio>
          </el-radio-group>
          <!-- 单选 -->
          <!-- 多选 -->
          <el-checkbox-group v-if="item.typehood == 2" v-model="item.answer">
            <el-checkbox
              v-for="(option, i) of item.options"
              :key="i"
              :label="option"
            >
              {{ option }}
            </el-checkbox>
          </el-checkbox-group>
          <!-- 多选 -->
          <!-- 填写 -->
          <el-input
            v-if="[3, 4, 5, 6, 7].includes(item.typehood)"
            v-model="item.answer[0]"
            :placeholder="'请输入' + item.title"
            class="fix-width"
          />
          <!-- 填写 -->
          <!-- 填写textarea -->
          <el-input
            v-if="item.typehood == 8"
            v-model="item.answer[0]"
            type="textarea"
            :placeholder="'请输入' + item.title"
          />
          <!-- 填写 -->
          <!-- 图片上传 -->
          <el-upload
            v-if="item.typehood == 9"
            :action="QNUploadURL"
            :data="uploadToken"
            list-type="picture-card"
            :file-list="item.answer"
            :on-success="
              function (res,file,fileList) {
                return handleImgSuccess(index,res,file,fileList)
              }
            "
            :on-remove="
              function (file,fileList) {
                return handleImgRemove(index,file,fileList)
              }
            "
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <!-- 图片上传 -->
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { sheetFind, updateRecord } from '@/api/questionRegForm'
import { getUploadToken } from '@/api/app'
import { QNUploadURL, QNHost } from '@/config/net.config'
export default {
  name: 'RecordEdit',
  emits: ['fetch-data'],
  data() {
    return {
      QNUploadURL,
      QNHost,
      sheetId: '',
      sheetRecordId: '',
      questionList: [],
      dialogFormVisible: false
    }
  },
  methods: {
    handleImgSuccess(index,res,file,fileList) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.questionList[index].answer.push({
        name: file.name,
        url: QNHost + '/' + res.hash,
      })
    },
    handleImgRemove(index,file, fileList) {
      this.questionList[index].answer = fileList.map((e) => ({
        name: e.name,
        url: e.url,
      }))
    },
    async showEdit(row) {
      const sheetRecordId = row.sheetRecordId
      const sheetId = row.sheetId
      const answerList = row.basic.answerList
      const res = await sheetFind({ sheetId })
      const questionList = res.basic.questionList || []
      questionList.forEach((e) => {
        const title = e.title
        const typehood = e.typehood
        const record = answerList.find((f) => f.title == title)
        if (record) {
            if(typehood==9) {
                e.answer = record.answer.map(g=>({name:'name',url:g}))
            }else {
                e.answer = [...record.answer]
            }
        } else {
          e.answer = []
        }
      })
      console.log('questionList',questionList)
      const token = await getUploadToken({})
      this.uploadToken = { token: token.token }
      this.sheetRecordId = sheetRecordId
      this.sheetId = sheetId
      this.questionList = questionList
      this.dialogFormVisible = true
    },
    close() {
      this.$refs['form'].resetFields()
      this.dialogFormVisible = false
    },
    save() {
          const sheetRecordId = this.sheetRecordId
          const questionList = this.questionList
          const answerList = []
          questionList.forEach(e=>{
              var obj = {}
              obj.title = e.title
              if(e.typehood==9) {
                  obj.answer = e.answer.map(f=>f.url)
                  obj.image = 1
              }else {
                  obj.image = 0
                  obj.answer = [...e.answer]
              }
              answerList.push(obj)
          })
        //   return console.log('answerList',answerList)
          this.$baseConfirm(
            `你确定要修改该记录吗`,
            null,
            async () => {
              await updateRecord({sheetRecordId,answerList})
              this.$baseMessage(
                `修改记录成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
    },
  },
}
</script>

<style lang="scss" scoped>
.mb-10 {
  margin-bottom: 10px;
}
.fix-width {
  width: 500px;
}
.ml-10 {
  margin-left: 10px;
}
</style>
